import { render, staticRenderFns } from "./companyNewsList.vue?vue&type=template&id=8a83c8c8&scoped=true"
import script from "./companyNewsList.vue?vue&type=script&lang=js"
export * from "./companyNewsList.vue?vue&type=script&lang=js"
import style0 from "./companyNewsList.vue?vue&type=style&index=0&id=8a83c8c8&prod&lang=scss"
import style1 from "./companyNewsList.vue?vue&type=style&index=1&id=8a83c8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83c8c8",
  null
  
)

export default component.exports